export default __webpack_public_path__ + "static/bidra-i-figma3-d7a91e8e613d656136ac4282b6eff4dd.png";